import { render, staticRenderFns } from "./property-details.vue?vue&type=template&id=a8a38f5c&"
import script from "./property-details.vue?vue&type=script&lang=js&"
export * from "./property-details.vue?vue&type=script&lang=js&"
import style0 from "./property-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QIcon,QCardSection,QSkeleton,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QIcon,QCardSection,QSkeleton,QImg})
